import Vue from 'vue'
import Vuex from 'vuex'
import server from "./server";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userList: [],
    accountsList: [],
    isSuperAdmin: true,
    accountTypeList: []
  },
  mutations: {
    setUserList(state, userList) {
      state.userList = userList
    },

    setAccountsList(state, accountsList) {
      state.accountsList = accountsList
    },

    setIsSuperAdmin(state, isSuperAdmin) {
      state.isSuperAdmin = isSuperAdmin
    },

    setAccountTypeList(state, accountTypeList) {
      state.accountTypeList = accountTypeList
    }
  },
  actions: {
  },
  modules: {
    server
  }
})
